export default "__VITE_ASSET__826b141b__"